import { render, staticRenderFns } from "./CustorAnaly_B.vue?vue&type=template&id=04683a40&scoped=true&"
import script from "./CustorAnaly_B.vue?vue&type=script&lang=js&"
export * from "./CustorAnaly_B.vue?vue&type=script&lang=js&"
import style0 from "./CustorAnaly_B.vue?vue&type=style&index=0&id=04683a40&scoped=true&lang=css&"
import style1 from "./CustorAnaly_B.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04683a40",
  null
  
)

export default component.exports